const Url = {
    //https://www.yingkelawyer.com/Ajax/Index/GetOrganizationList.ashx?_=0.1413258641874966&t=get_officename_list
    // apiUrl: "http://localhost:8094/api/"
    // apiUrl: "http://172.16.18.114:2444/api/",
    apiUrl: "http://www.yingkelawyer.com/Ajax/Index/IndexAjax.ashx",
    siteUrl:"https://www.yingkelawyer.com/Ajax/Index/GetOrganizationList.ashx"
  };
  
  export default Url;